export default "__VITE_ASSET__3c9637b8__"